import React from 'react';
import { Routes, Route, HashRouter } from 'react-router-dom';
import { Layout } from '../components';
import { routes } from './config';

const AppRouter = () => {
  return (
    <HashRouter>
    <Routes>
      <Route element={<Layout />}>
        {routes.map(({ path, Element }, index) => (
          <Route key={index} path={path} element={<Element />} />
        ))}
      </Route>
    </Routes>
  </HashRouter>
);
};

export default AppRouter;
